import { FC, useState } from 'react';
import {
  Button,
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  Input,
} from '@features/ui';
import { SUPPORT_EMAIL } from '@src/constants';

interface ContactSupportPopupProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export const ContactSupportPopup: FC<ContactSupportPopupProps> = ({
  open,
  onOpenChange,
}) => {
  const [copied, setCopied] = useState(false);

  const handleCopyAndEmail = async () => {
    try {
      await navigator.clipboard.writeText(SUPPORT_EMAIL);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
      onOpenChange(false);
      window.location.href = `mailto:${SUPPORT_EMAIL}`;
    } catch {
      setCopied(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent size="xl">
        <DialogHeader>
          <DialogTitle>Contact Support</DialogTitle>
          <DialogDescription className="text-xs text-white/80">
            Email our support team directly. Click copy to copy the email and
            open your email client.
          </DialogDescription>
        </DialogHeader>
        <div className="flex flex-col gap-6 mt-2">
          <div>
            <p className="font-semibold mb-2">Email our support team</p>
            <div className="flex items-center gap-2">
              <Input
                readOnly
                className="w-60 text-xs"
                value={SUPPORT_EMAIL}
                onFocus={(e) => e.target.select()}
              />
              <Button size="sm" variant="lime" onClick={handleCopyAndEmail}>
                {copied ? 'Copied & Redirected!' : 'Copy & Email'}
              </Button>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
